/**
 * Checks whether a caught error is due to the browser storage quota (i.e. capacity) being exceeded.
 *
 *
 * @param err - The caught value from a failed `storage.setItem` call
 * @returns `true` if `err` is a QuotaExceededError (or its legacy name/code), else `false`
 */
export function isQuotaExceededError(err: unknown): err is DOMException {
  return (
    err instanceof DOMException &&
    (err.name === 'QuotaExceededError' ||
      err.name === 'NS_ERROR_DOM_QUOTA_REACHED') // Older Firefox / Edge
  )
}
